export default __webpack_public_path__ + "f2d79bb5a8832b9d09e2a593e75ed97b.png";